import classNames from "classnames";
import styles from "./landingCard.module.css";

const LandingCard = ({ children, onClick }) => {
  return (
    <div className={classNames(styles.landingCard, {[styles.clickable]: typeof onClick === "function"})} onClick={onClick}>
      {children}
    </div>
  );
};

export default LandingCard;
